//
import Model from '@/models/Model'

/**
 * @description
 * This class describes a hr finiquito status.
 *
 * @class   HrFiniquitoStatus (name)
 */
export default class HrFiniquitoStatus extends Model {

    /**
     * @description
     * { function_description }
     *
     * @return     {string}  { description_of_the_return_value }
     */
    resource() {
        return 'hr_finiquito_status'
    }
}
